module.exports = __webpack_public_path__ + "assets/img/scenic_08.ff2b3c0e.svg";